import './Card.sass';

import { FC } from 'react';
import { classNames } from '$utils';
import { CardProps } from './Card.interface';

export const Card: FC<CardProps> = ({
  after,
  before,
  className,
  containerClassName,
  onClick,
  children,
  title,
}) => {
  return (
    <div className={classNames('Card', className)} onClick={onClick}>
      {!!before && <div className="Card_before">{before}</div>}
      <div className={classNames('Card__container', containerClassName)}>
        <div className="Card__title">{title}</div>
        <div className="Card__text">{children}</div>
      </div>
      {!!after && <div className="Card_after">{after}</div>}
    </div>
  );
};
